<template>
  <h4>Step {{ current }} of {{ count }}</h4>
</template>

<script>
export default {
  props: [
    'current',
    'count'
  ]
}
</script>
